import Request from './Request';

export interface IScoreboard {
    id: number;
    name: string;
    code: string;
    tradeSalesForecastWeek1: number;
	tradeSalesForecastWeek2: number;
	tradeSalesForecastWeek3: number;
	tradeSalesForecastWeek4: number;
	tradeSalesMonthTodayWeek1: number;
	tradeSalesMonthTodayWeek2: number;
	tradeSalesMonthTodayWeek3: number;
	tradeSalesMonthTodayWeek4: number;
    tradeSalesSRE: number;
	tradeSalesFRE: number;
	tradeSalesLE: number;
	tradeSalesOP: number;
	tradeSalesBusinessPlan: number;
	tradeSalesActual: number;
    active: boolean;
    children: IScoreboard[];
}

class Score {
    static Get = (id: number): IScoreboard => { return Request.DoGet('scoreboard/' + id) as unknown as IScoreboard; };
    static GetByCode = (code: string, year: number, month: number): IScoreboard => { return Request.DoGet('scoreboard/' + code + "/" + year + "/" + month) as unknown as IScoreboard; };
    static GetYTDByCode = (code: string, year: number, month: number): IScoreboard => { return Request.DoGet('scoreboard/ytd/' + code + "/" + year + "/" + month) as unknown as IScoreboard; };
}

export default Score;